import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { catchError, ReplaySubject, Subject, takeUntil, throwError } from 'rxjs';
import { NavBarComponent } from 'src/app/nav-bar/nav-bar.component';
import { AddressModel } from 'src/app/order-to-cash/models-otc/address-model';
import { CustomerModel } from 'src/app/order-to-cash/models-otc/customer-model';
import { OrdersModel } from 'src/app/order-to-cash/models-otc/orders-model';
import { RepresentativeModel } from 'src/app/order-to-cash/models-otc/representative-model';
import { CustomerService } from 'src/app/order-to-cash/services-otc/customer.service';
import { OrdersService } from 'src/app/order-to-cash/services-otc/orders.service';
import { ChangeDetectorRef } from '@angular/core';

@Component({
    selector: 'app-copy-order',
    templateUrl: './copy-order.component.html',
    styleUrls: ['./copy-order.component.css'],
    standalone: false
})
export class CopyOrderComponent implements OnInit, OnDestroy, AfterViewInit {

  copyOrderForm: FormGroup;
  selectedSoldToCustomer: CustomerModel;
  selectedPayerCustomer: CustomerModel;
  customers: CustomerModel[];
  representative: RepresentativeModel;
  orderObj: OrdersModel = <OrdersModel>{};

  orderId = null;
  soldToObj = null;
  payerObj = null;

    public filteredAltAddresses: ReplaySubject<AddressModel[]> = new ReplaySubject<AddressModel[]>(1);
    public filteredSoldTos: ReplaySubject<CustomerModel[]> = new ReplaySubject<CustomerModel[]>(1);
    public filteredPayers: ReplaySubject<CustomerModel[]> = new ReplaySubject<CustomerModel[]>(1);
    public soldToFilterCtrl: FormControl<string> = new FormControl<string>('');
    public payerFilterCtrl: FormControl<string> = new FormControl<string>('');
    protected _onAltAddressDestroy = new Subject<void>();
    protected _onSoldToDestroy = new Subject<void>();
    protected _onPayerDestroy = new Subject<void>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<CopyOrderComponent>,
    private copyOrderFb: FormBuilder,
    private customerService: CustomerService,
    private ordersService: OrdersService,
    public nav: NavBarComponent,
    private router: Router,
    public snackBar: MatSnackBar,
    private cdref: ChangeDetectorRef
  ) { 

    this.copyOrderForm = this.copyOrderFb.group({
           soldToId: [null, Validators.required],
           payerId: [null, Validators.required]
    });
  }

  ngOnInit(): void {
    this.orderId = this.data.orderId;
    this.soldToObj = this.data.soldToObj;
    this.payerObj = this.data.payerObj;

    this.populateSoldToCustomerDetails();
    this.populatePayerCustomerDetails();
  }

    populateSoldToCustomerDetails() {
      this.customerService.getCustomerDetailsByPriceList(this.soldToObj?.id)
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.customers = response;
          this.setInitialSoldToList();
  
        });
    }

    populatePayerCustomerDetails() {
      this.customerService.getCustomerDetails()
        .pipe(
          catchError((error) => {
            console.error(error);
            return throwError(() => error);
          })
        )
        .subscribe((response) => {
          this.customers = response;
          this.setInitialPayerList();
        });
    }

    ngAfterViewInit(){
      if(this.copyOrderForm.controls.soldToId.value === null){
        this.copyOrderForm.controls.soldToId.setValue(this.soldToObj.id);
        this.cdref.detectChanges();
      }

      if(this.copyOrderForm.controls.payerId.value === null){
        this.copyOrderForm.controls.payerId.setValue(this.payerObj?.id);
        this.cdref.detectChanges();
      }
    
    }

    setInitialSoldToList() {
      // Load the initial sold to list
      this.filteredSoldTos.next(this.customers.slice());
      // Listen for search field value changes
      this.soldToFilterCtrl.valueChanges
        .pipe(takeUntil(this._onSoldToDestroy))
        .subscribe(() => {
          this.filterSoldTos();
        });
    }

    setInitialPayerList() {
      // Load the initial payer list
      this.filteredPayers.next(this.customers.slice());
      // Listen for search field value changes
      this.payerFilterCtrl.valueChanges
        .pipe(takeUntil(this._onPayerDestroy))
        .subscribe(() => {
          this.filterPayers();
        });
    }

    protected filterSoldTos() {
      if (!this.customers) {
        return;
      }
      // Get the search keyword
      let search = this.soldToFilterCtrl.value;
      if (!search) {
        this.filteredSoldTos.next(this.customers.slice());
        return;
      } else {
        search = search.toLowerCase();
      }
      // Filter the Sold To's based on the search keyword
      this.filteredSoldTos.next(
        this.customers.filter(soldTo => soldTo.name.toLowerCase().indexOf(search) > -1 || soldTo.ysapCode.toLowerCase().indexOf(search) > -1)
      );
    }

    protected filterPayers() {
      if (!this.customers) {
        return;
      }
      // Get the search keyword
      let search = this.payerFilterCtrl.value;
      if (!search) {
        this.filteredPayers.next(this.customers.slice());
        return;
      } else {
        search = search.toLowerCase();
      }
  
      // Filter the payers based on the search keyword
      this.filteredPayers.next(
        this.customers.filter(payer => payer.name.toLowerCase().indexOf(search) > -1 || payer.ysapCode.toLowerCase().indexOf(search) > -1)
      );
    }
  


  setSelectedSoldTo(customer: CustomerModel) {
    this.selectedSoldToCustomer = customer;
  }

  setSelectedPayer(customer: CustomerModel) {
    this.selectedPayerCustomer = customer;
  }

  copyOrder(){

    this.nav.toggleLoading(true);

     if(sessionStorage.getItem('representative') !== null){
       this.representative =  JSON.parse(sessionStorage.getItem('representative'));
     }
    
     let soldToId = null;
     let payerId = null;

     if(this.selectedSoldToCustomer){
        soldToId = this.selectedSoldToCustomer?.id;
     }else{
      soldToId = this.soldToObj?.id
     }

    if(this.selectedPayerCustomer){
        payerId = this.selectedPayerCustomer?.id;
     }else{
      payerId = this.payerObj?.id
     }
     
       this.ordersService.postCopyOrder(this.orderId, soldToId, payerId, this.representative?.representativeId)
       .pipe(
           catchError((error) => {
             console.error(error);
             return throwError(() => error);
           })
       )
       .subscribe((responseOrderId) => {
         this.ordersService
             .getOrderById(responseOrderId)
             .pipe(
                 catchError((error) => {
                   console.error(error);
                   return throwError(() => error);
                 })
             )
             .subscribe((responseOrderDetails) => {
               this.orderObj = responseOrderDetails;

               let copyOrderInfo = {
                option: "createCopy",
                responseOrderId: responseOrderId
            }
               this.dialogRef.close(copyOrderInfo);
             });
       });
  }



  cancelCopyingOrder(){
    this.dialogRef.close({option: "cancelCopy"});
  }

  ngOnDestroy() {
    this._onSoldToDestroy.next();
    this._onSoldToDestroy.complete();

    this._onPayerDestroy.next();
    this._onPayerDestroy.complete();
  }
}
